import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";

export type SidebarIconMotionKind =
  | "account"
  | "broadcasts"
  | "customers"
  | "flows"
  | "home"
  | "inbox"
  | "orders"
  | "products"
  | "sequences"
  | "tools"
  | "triggers";

export function SidebarIconMotion({
  children,
  kind,
}: {
  children: ReactNode;
  kind: SidebarIconMotionKind;
}) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.span
      className={`sidebar-icon-motion sidebar-icon-motion--${kind}`}
      whileTap={prefersReducedMotion ? undefined : { scale: 0.94 }}
      transition={{ duration: 0.18, ease: "easeOut" }}
    >
      {children}
    </motion.span>
  );
}
